// @flow
import React from 'react';
import {
  connect
} from 'react-redux';
import { Grid } from 'semantic-ui-react';
import {
  withRouter
} from 'react-router-dom'
import {
  bindActionCreators
} from 'redux';
import { fetchPersonas } from '../actions/personas';
import CommunityTile from './CommunityTile';
import { getPersonasSortedAlphabetically } from '../reducers/personas';
import type { Persona as Personas } from '../types';
type Props = {
  fetchPersonas: () => Promise<void>,
  personas: Personas,
  persona_slug: string,
  history: any,
};

class HelixPersonaList extends React.Component<Props> {

  componentDidMount() {
    // console.log(this.props);
    this.props.fetchPersonas();
  }
  render() {
    const { personas , persona_slug } = this.props;
    const personaTiles = personas
      ? personas.map((persona, key) => {
          if (persona && persona.acf) {
            return (
              <CommunityTile
                key={key}
                colour={persona.acf.color}
                communitySlug={persona.slug + "-" + persona.acf.title.toLowerCase().replace(" - ","-").replace(" ","-").replace(" ","-").replace(" ","-")}
                image={persona.acf.featuredImage.url}
                title={persona.postTitle}
                summary={persona.acf.summaryExcerpt}
                communityImageGallery={persona.acf.communityImageGallery}
                personas={persona.personas}
                acf={persona.acf}
                slug={persona_slug}
              />
            );
          } else {
            return '';
          }
        })
      : [];

    return (
      <div className="page-row">
        <h2 className="browse-helix-personas__header">Browse Helix Personas</h2>
        <div className="community-tiles">
          <Grid stackable centered verticalAlign="middle">
            <div className="community-tiles-flex">{personaTiles}</div>
          </Grid>
        </div>
      </div>
    );
  }
}
const mapStateToProps = state => {
  return {
    personas: getPersonasSortedAlphabetically(state)
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({
      fetchPersonas
    },
    dispatch
  );

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(HelixPersonaList));
